import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { EnvironmentProviders, Provider } from '@angular/core';
import { HeadersInterceptor } from './headers.interceptor';
import { ErrorCatchingInterceptor } from './error-catching.interceptor';
import { ApiErrorToastInterceptor } from './api-error-toast.interceptor';

export const httpInterceptorProviders: (Provider | EnvironmentProviders)[] = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HeadersInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorCatchingInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ApiErrorToastInterceptor,
    multi: true,
  },
];
